import classNames from 'classnames';
import React from 'react';
import { useLocaleStore } from '@/i18n';
import artTextIcon from '@/panels/text-layer/assets/art-text.svg';
import './style.less';

type Props = React.ComponentProps<'div'> & {
    onClick: () => void;
};

export const ArtTextEntry: React.FC<Props> = ({ style = {}, onClick }) => {
    const { $t } = useLocaleStore();

    const cls = classNames('modal-panel-entry');

    return (
        <div className={cls} style={style} onClick={onClick}>
            <div className="modal-panel-entry__thumbnail">
                <img className="modal-panel-entry__img" src={artTextIcon} />
            </div>
            <span>{$t((v) => v.collapse.moreCollapse.textTool.aiText.title)}</span>
        </div>
    );
};
